module.exports = __webpack_public_path__ + "static/media/pen.78a058cc.svg";